import type { ComponentProps, FC } from 'react';

import { Success } from './components/Success';
import { StyledModal } from './styled';

type ISuccessModalProps = ComponentProps<typeof StyledModal> & {
    isOpen: boolean;
    onClose: () => void;
    isSuccess: boolean;
    successTitle: string;
    successText: string;
};

export const SuccessModal: FC<ISuccessModalProps> = ({
    isOpen,
    onClose,
    isSuccess,
    children,
    successTitle,
    successText,
    title,
    footer,
    ...props
}) => {
    return (
        <StyledModal
            isOpen={isOpen}
            onClose={onClose}
            isSuccess={isSuccess}
            title={!isSuccess && title}
            footer={!isSuccess && footer}
            {...props}
        >
            {isSuccess ? (
                <Success
                    onClick={onClose}
                    title={successTitle}
                    text={successText}
                />
            ) : (
                <>{children}</>
            )}
        </StyledModal>
    );
};
